import {Box, Grid, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import React, {useState} from 'react'
import t from "../../../Utils/Translation";
import { Worker } from '@react-pdf-viewer/core';
import { Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { PageLayout } from '@react-pdf-viewer/core';
import {defaultLayoutPlugin} from "@react-pdf-viewer/default-layout";

const JobAnnouncement = (props) => {



    const jobAnnouncementUrl = localStorage.getItem("i18n")==="it" ? "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Videos+for+Comparative+Evaluation+Activity/Annuncio+IRC217703+VALUTAZIONE.pdf": "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/ENI/Job+announcement_JuniorR%26DFermentation+(VALUTAZIONE)+ENG.pdf";

    const transform = (slot) => ({
        ...slot,
        // These slots will be empty
        Open: () => <></>
    });


    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    )
    const defaultLayoutPluginInstance = defaultLayoutPlugin({renderToolbar,});

    const {renderDefaultToolbar} = defaultLayoutPluginInstance.toolbarPluginInstance
    return (
        <div  style={{ flexGrow: 1 }}>
            <Grid container spacing={3}>
                <Grid item xs={8}>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.1.81/build/pdf.worker.min.js">
                        <Box height={'80vh'} position={'relative'} ml={2}>
                            <Typography variant="h5" align={'center'}>
                                {t("Job announcement")}
                            </Typography>
                            <div   style={{
                                height: '100%',
                                width: '100%'
                            }}>
                                <Viewer fileUrl={jobAnnouncementUrl} plugins={[defaultLayoutPluginInstance]} />;
                            </div>

                        </Box>
                    </Worker>

                </Grid>
                <Grid item xs={4}>
                    <Box height={'80vh'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                            <Button className={'mx-5'} onClick={props.handleNextStep} style={{background: "linear-gradient(to bottom, #006f4b, #006f4b)", color: "white", borderRadius: '15px', paddingLeft: '100px', paddingRight: '100px', paddingTop: '20px', paddingBottom:'20px', fontSize: '24px' }}>{t("PROCEED TO VISUALIZE THE CV'S")}</Button>
                    </Box>
                </Grid>
            </Grid>
        </div>
    )
}

export default JobAnnouncement